<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.consult_quote_edit')">
        <ConsultQuoteEdit></ConsultQuoteEdit>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.consult_quote_vend_set')">
        <ConsultQuoteExecute></ConsultQuoteExecute>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.consult_quote_vend_price_approved')">
        <ConsultQuoteTracking></ConsultQuoteTracking>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.consult_quote_vend_price_search')">
        <ConsultQuoteSearch></ConsultQuoteSearch>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.consult_quote_vend_distribution')">
        <ConsultPreDistribution></ConsultPreDistribution>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ConsultQuoteEdit from './ConsultQuoteEdit.vue';
import ConsultQuoteExecute from './ConsultQuoteExecute.vue';
import ConsultQuoteTracking from './ConsultQuoteTracking.vue';
import ConsultQuoteSearch from './ConsultQuoteSearch.vue';
import ConsultPreDistribution from './ConsultPreDistribution.vue'

export default {
  components: {
    ConsultQuoteEdit,
    ConsultQuoteExecute,
    ConsultQuoteTracking,
    ConsultQuoteSearch,
    ConsultPreDistribution,
  },
  data() {
    return {
      tab_index: 0
    }
  },
}
</script>
